export enum IconType {
  chevronUp = 'chevronUp',
  chevronDown = 'chevronDown',
  chevronRight = 'chevronRight',
  chevronLeft = 'chevronLeft',
  arrowRight = 'arrowRight',
  arrowUpRight = 'arrowUpRight',
  creatopyLogo = 'creatopyLogo',
  theBriefLogo = 'theBriefLogo',
  burgerMenu = 'burgerMenu',
  close = 'close',
  closeSmall = 'closeSmall',
  languages = 'languages',
  filter = 'filter',
  checkBoxSelected = 'checkBoxSelected',
  checkBox = 'checkBox',
  searchNotFound = 'searchNotFound',
  starFilled = 'starFilled',
  checkmark = 'checkmark',
  customPricing = 'customPricing',
  arrowDown = 'arrowDown',
  information = 'information',
  theBriefFooterLogo = 'theBriefFooterLogo',
  star = 'star',
  arrowUp = 'arrowUp',
  loopLogo = 'loopLogo',
  empty = 'empty',
}

export default IconType;
